import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { formatDateWithYear } from "@/utils/dateFormatters";
import BreadcrumbComponent from "@/components/BreadcrumbComponent";
import { BookOpen, Trophy } from "lucide-react";
import CardSkeleton from "@/components/CardSkeleton";
import { useSwimmersDiary } from "@/hooks/useSwimmersDiary";
import SwimmersDiaryStub from "@/components/SwimmersDiaryStub";
import { Typography } from "@/components/ui/typography";

const SwimmersDiary = () => {
  const { swimmersDiaryData, isLoading } = useSwimmersDiary();
  return (
    <div className="flex w-full flex-col p-3">
      <BreadcrumbComponent link={"Дневник пловца"} />
      <div className="mb-6 flex items-center gap-2">
        <BookOpen className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-medium text-gray-900">Дневник пловца</h2>
      </div>
      <div className="m:grid-cols-1 grid gap-4">
        {!isLoading && swimmersDiaryData && swimmersDiaryData.length === 0 && <SwimmersDiaryStub />}
      </div>
      <div className="m:grid-cols-1 grid gap-4">
        {isLoading
          ? [...Array(1)].map((_, index) => <CardSkeleton key={index} />)
          : swimmersDiaryData &&
            swimmersDiaryData.map((achievement, index) => (
              <Card key={index} className="overflow-hidden">
                <CardHeader className="border-b bg-muted/50 p-4">
                  <div className="flex flex-col gap-2">
                    <div className="group flex items-center gap-3">
                      <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                        <Trophy className="h-5 w-5 text-primary" />
                      </div>
                      <Typography
                        variant="h3"
                        className="min-w-[40rem] break-normal text-lg font-normal text-gray-800 transition-colors group-hover:text-primary md:min-w-[20rem]"
                      >
                        {achievement.skill}
                      </Typography>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="space-y-4 p-4">
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between text-sm">
                      <Typography variant="muted" className="text-muted-foreground">
                        Раздел:{" "}
                      </Typography>
                      <Typography variant="p" className="text-base leading-relaxed">
                        {achievement.section}
                      </Typography>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <Typography variant="muted" className="text-muted-foreground">
                        Дата получения:{" "}
                      </Typography>
                      <Typography variant="p" className="text-base leading-relaxed">
                        {formatDateWithYear(achievement.completion_date)}
                      </Typography>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
      </div>
    </div>
  );
};

export default SwimmersDiary;
